import React, { FC } from 'react'

type Props = {
  className?: string
  label: string
  leftText?: string
  onRightTextClick?: () => void
  renderRightContent?: () => JSX.Element | null
  rightText?: string | number
  rightTextUnderline?: boolean
}

export const OverviewRow: FC<Props> = ({
  className = '',
  label,
  leftText,
  renderRightContent,
  rightText,
  rightTextUnderline = false,
  onRightTextClick,
}) => {
  return (
    <div
      className={`flex h-16 w-full items-center justify-between border-b border-secondary ${className}`}
      style={{ overflowWrap: 'break-word' }}
    >
      <div>
        <span className="whitespace-nowrap text-tertiary">{`${label}${leftText ? ': ' : ''}`}</span>
        <span className="font-weight[500] font-bold">{leftText}</span>
      </div>

      {!!rightText && (
        <span
          className={`font-weight[500] overflow-auto font-bold ${rightTextUnderline && `underline underline-offset-2`}`}
          onClick={() => onRightTextClick && onRightTextClick()}
          role="presentation"
        >
          {rightText.toString()}
        </span>
      )}

      {!!renderRightContent && renderRightContent()}
    </div>
  )
}
